import * as React from "react"
import "./TopMenu.scss";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";

const TopMenu = (props: any) => {

    const [t, i18n] = useTranslation();
    const { user, signoutRedirect } = useAuth();
    
    const setActiveLanguage = (language: string) => {
        i18n.changeLanguage(language);
        props.onLanguageChange(language);
    }

    React.useEffect(() => {
        (document.querySelector('dw-unifiedheader') as HTMLElement).addEventListener('dwMenuLanguageChanged', event => {
            setActiveLanguage((event as any).detail)
        });

        (document.querySelector('dw-unifiedheader') as HTMLElement).addEventListener('dwMenuloggedout', event => {
            signoutRedirect();
        });

    }, []);

    return (
        <div className="top-menu-wrapper">
            <dw-unifiedheader client-id="MarketingAndSalesToolUnifiedHeader" token-is-provided={true}></dw-unifiedheader>
        </div>
    );
}


export default TopMenu;